import create from 'zustand'

export const qcInitialData = []
const useQcStore = create((set) => ({
  qc: [],
  qcLoading: true,
  setQcLoading: (loading) => set({ qcLoading: loading }),
  setQc: (qc) => set((state) => ({
    ...state,
    qc,
    qcLoading: false
  })),
  resetQc: () => set(() => ({
    qc: qcInitialData,
    qcLoading: true
  })),
  deleteQC: (id) => set((state) => ({
    ...state,
    qc: state.qc.filter((item) => item.id !== id)
  }))
}))

export default useQcStore
